







































































































































































import Vue from "vue";
import Component from "vue-class-component";
import CbxOwner from "@/views/lookups/CbxOwner.vue";
import CbxProductProvider from "@/views/lookups/CbxProductProvider.vue";
import CbxLiabilityTypes from "@/views/lookups/CbxLiabilityTypes.vue";
import {
  FactFindLiabilityOtherDto,
  CreateLiabilityOtherCommand,
  OwnerDto,
  LiabilityTypeDto,
  ProductProviderDto,
  FactFindAssetDto,
  UpdateLiabilityOtherCommand,
  ClientSelector
} from "@/api/ClientPortalApiClient";
import ApiFactory from "../../api/ApiFactory";
import AlertService from "../../services/alert.service";
import { LoadingSpinnerService } from "@/store";
import { FormatDate } from "../../filters/FormatDate";

@Component({
  components: {
    CbxOwner,
    CbxProductProvider,
    CbxLiabilityTypes
  }
})
export default class FactFindLiabilityOther extends Vue {
  private alertService = new AlertService();
  private others: FactFindLiabilityOtherDto[] = [];
  private emptyLiability = new FactFindLiabilityOtherDto();
  private displayModel = new FactFindLiabilityOtherDto();
  private selectLiability = new FactFindLiabilityOtherDto();
  private formEnabled: boolean = false;
  private mode: string = "default";
  private clientNames: OwnerDto[] = [];
  private modelSig = "";
  private contactId: number = 0;

  async created() {
    this.contactId = parseInt(this.$route.params.contactId);
    await this.loadOthers(true);
    await this.getClientSelectorNames();
  }

  $refs!: {
    owner: CbxOwner;
    liabilityType: CbxLiabilityTypes;
    productProvider: CbxProductProvider;
    mainForm: HTMLFormElement;
  };

  private async getClientSelectorNames() {
    const api = ApiFactory.CreateDataClient();
    const data = await api.owner_Index(this.contactId);
    this.clientNames = data || [];
  }

  private otherDisplayName(other: FactFindLiabilityOtherDto): string {
    const owner = this.clientNames.find(x => x.id === other.owner);
    return (
      (owner ? owner.name : "") +
      " - " +
      (other.liabilityType ? other.liabilityType.name : "")
    );
  }

  saveOther(e: Event) {
    e.preventDefault();
    if (this.mode === "update") {
      this.update();
    } else if (this.mode === "create") {
      this.createNew();
    }
  }

  private async createNew(): Promise<boolean> {
    LoadingSpinnerService.Show("Saving new Liability...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new CreateLiabilityOtherCommand();

    cmd.contactId = this.contactId;
    cmd.owner = this.displayModel.owner;
    cmd.termInYears = this.displayModel.termInYears;
    cmd.amountBorrowed = this.displayModel.amountBorrowed;
    cmd.currentBalance = this.displayModel.currentBalance;
    cmd.monthlyRepayment = this.displayModel.monthlyRepayment;
    cmd.annualPercentageRate = this.displayModel.annualPercentageRate;
    cmd.otherDetails = this.displayModel.otherDetails;

    cmd.dateStarted = FormatDate.forApi(this.displayModel.dateStarted);

    if (this.displayModel.lender) {
      cmd.lenderId = this.displayModel.lender.id;
    }
    if (this.displayModel.liabilityType) {
      cmd.liabilityTypeId = this.displayModel.liabilityType.id;
    }

    try {
      const result = await api.factFindLiabilityOther_IndexPOST(cmd);
      this.displayModel.id = result;
      await this.loadOthers();
      this.displayModel =
        this.others.find(x => x.id === result) || this.displayModel;
      this.mode = "update";
      this.modelSig = this.displayModel.toJSON();
      LoadingSpinnerService.Success("Liability saved successfully");
      return true;
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Could not save Liability. Please try again."
      );
    }

    return false;
  }

  private async update(): Promise<boolean> {
    LoadingSpinnerService.Show("Updating Liability...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new UpdateLiabilityOtherCommand();

    cmd.contactId = this.contactId;
    cmd.id = this.displayModel.id;
    cmd.owner = this.displayModel.owner;
    cmd.termInYears = this.displayModel.termInYears;
    cmd.amountBorrowed = this.displayModel.amountBorrowed;
    cmd.currentBalance = this.displayModel.currentBalance;
    cmd.monthlyRepayment = this.displayModel.monthlyRepayment;
    cmd.annualPercentageRate = this.displayModel.annualPercentageRate;
    cmd.otherDetails = this.displayModel.otherDetails;

    cmd.dateStarted = FormatDate.forApi(this.displayModel.dateStarted);

    if (this.displayModel.lender) {
      cmd.lenderId = this.displayModel.lender.id;
    }
    if (this.displayModel.liabilityType) {
      cmd.liabilityTypeId = this.displayModel.liabilityType.id;
    }

    try {
      await api.factFindLiabilityOther_IndexPUT(cmd);
      this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
      LoadingSpinnerService.Success("Liability updated successfully");
      return true;
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Could not save Liability. Please try again."
      );
    }

    return false;
  }

  private async loadOthers(showLoader: boolean | undefined = undefined) {
    if (showLoader) LoadingSpinnerService.Show("Loading Liabilitys...");
    const api = ApiFactory.CreateDataClient();
    try {
      const result = await api.factFindLiabilityOther_IndexAll(this.contactId);
      this.others = result || [];
      if (showLoader) LoadingSpinnerService.Hide();
    } catch (e) {
      this.others = [];
      LoadingSpinnerService.Failure(
        "Could not load Liabilitys. Please try again."
      );
    }
  }

  private async rowSelected(item: FactFindLiabilityOtherDto) {
    if (!(await this.checkForChanges())) {
      return;
    }

    this.clearData();
    this.formEnabled = true;
    this.mode = "update";
    this.displayModel = item;

    this.displayModel.dateStarted = FormatDate.forInput(item.dateStarted);

    if (this.displayModel.owner) {
      this.$refs.owner.setSelected(this.displayModel.owner);
    } else {
      this.$refs.owner.setSelected(ClientSelector.Main);
    }

    this.$refs.liabilityType.setSelected(this.displayModel.liabilityType);
    this.$refs.productProvider.setSelected(this.displayModel.lender);

    this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
  }

  private createClicked() {
    this.clearData();
    this.mode = "create";
    this.formEnabled = true;
  }

  private updateClicked() {
    this.mode = "update";
    this.formEnabled = true;
  }

  private clearData() {
    this.displayModel = this.emptyLiability;
    this.displayModel.owner = ClientSelector.Main;
    this.$refs.owner.setSelected(ClientSelector.Main);
    this.$refs.liabilityType.setSelected(new LiabilityTypeDto());
    this.$refs.productProvider.setSelected(new ProductProviderDto());
  }

  public async checkForChanges(): Promise<boolean> {
    if (this.isDisplayModelEmpty() == false) {
      if (this.hasChanges() == true) {
        if (confirm("Would you like to save your changes?")) {
          return await this.saveChanges();
        }
      }
    }

    return true;
  }

  public async saveChanges(): Promise<boolean> {
    if (this.$refs.mainForm.checkValidity()) {
      if (this.mode === "update") {
        return await this.update();
      } else if (this.mode === "create") {
        return await this.createNew();
      }

      return true;
    }

    this.alertService.error(
      "Form Validation Failed",
      "Please complete all required fields"
    );
    return false;
  }

  private isDisplayModelEmpty(): boolean {
    return (
      this.mode !== "create" &&
      JSON.stringify(this.displayModel.toJSON()) ===
        JSON.stringify(this.emptyLiability.toJSON())
    );
  }

  private hasChanges(): boolean {
    const s1 = JSON.stringify(this.displayModel.toJSON()).toString();
    if (s1 !== this.modelSig) {
      return true;
    } else {
      return false;
    }
  }

  private ownerSelected(owner: ClientSelector) {
    this.displayModel.owner = owner;
  }
  private liabilityTypeSelected(liabilityType: LiabilityTypeDto) {
    this.displayModel.liabilityType = liabilityType;
  }
  private productProviderSelected(productProvider: ProductProviderDto) {
    this.displayModel.lender = productProvider;
  }
}
